/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { SupportPlanResponse } from '../../types/common/PlanSupport';

export enum ModalType {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  ERROR = 'ERROR',
}

export type ModalProps = {
  type: ModalType;
  supportPlan?: SupportPlanResponse;
  error?: string;
};
